import { ActivityCompletionStatusFilter } from '@cobliteam/api-lib';
import { useTranslation } from '@cobliteam/i18n';
import Checkbox from '@cobliteam/ui/form/Checkbox';
import Label from '@cobliteam/ui/form/Label';

interface ActivityStatusItemProps {
  status: ActivityCompletionStatusFilter;
  onChange: () => void;
  checked: boolean;
}

const ActivityStatusItem = ({ status, onChange, checked }: ActivityStatusItemProps) => {
  const { t } = useTranslation('multiselects');

  const getStatusLabel = (status: ActivityCompletionStatusFilter) => {
    if (status === ActivityCompletionStatusFilter.COMPLETED) {
      return t('activity_status.status_completed');
    }
    if (status === ActivityCompletionStatusFilter.NOT_COMPLETED) {
      return t('activity_status.status_not_completed');
    }
    if (status === ActivityCompletionStatusFilter.PLANNED) {
      return t('activity_status.status_pending');
    }
    return status;
  };

  return (
    <div className='flex items-center gap-2'>
      <Checkbox key={`activity-status-${status}`} id={`activity-status-${status}`} checked={checked} onCheckedChange={onChange} />
      <Label htmlFor={`activity-status-${status}`}>{getStatusLabel(status)}</Label>
    </div>
  );
};

export default ActivityStatusItem;
